import * as React from "react";
import type { SVGProps } from "react";
const SvgVisibilityOff = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentcolor"
            fillRule="evenodd"
            d="m5.336 8.25-3.043 3.043a1 1 0 1 0 1.414 1.414L6.75 9.664 9 11.915 9 12a3 3 0 0 0 3.085 2.999l1.799 1.8a6 6 0 0 1-6.127-1.456L6.54 14.126a1 1 0 1 0-1.414 1.414l1.217 1.217a8 8 0 0 0 9.077 1.578l1.373 1.372.707.707L18.914 19l-.707-.707-4.13-4.13a3 3 0 1 0-4.242-4.242L5.708 5.794 5 5.086 3.586 6.5l.707.707zM19.586 12l-2.436 2.436 1.414 1.414 3.143-3.143.707-.707-.707-.707-4.05-4.05A8 8 0 0 0 8.445 5.73l1.522 1.523a6 6 0 0 1 6.275 1.404z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgVisibilityOff;
